import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { InventarioService } from './inventario.service';
import { Etapa, EtapaEstrutura } from './models/inventario';




@Injectable({ providedIn: 'root'})
export class EtapaResolver implements Resolve<Observable<Etapa>>{

    constructor(private inventarioService: InventarioService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const idEtapa = route.params.idEtapa;
        return this.inventarioService.getEtapa(idEtapa);
    }

}